module.exports = __webpack_public_path__ + "img/home-8.f46e327f.png";